<div [ngClass]="( !(esconderTipoProduto && tipoProdutoSelecionado) ? 'ui-g form-group' : '' )">
  <div
    class="tipo-produto ui-g-4"
    [ngClass]="{
                'tipo-produto padding-left-zero' : paddingLeftZero,
                'padding-top-zero'               : paddingTopZero
               }"
    *ngIf=" !(esconderTipoProduto && tipoProdutoSelecionado) ">
    <p-dropdown
      name="tipoProduto"
      tabindex="1"
      [style]="{'width':'100%'}"
      [inputStyle]="{'width':'100%'}"
      [(ngModel)]="tipoProdutoSelecionado"
      [options]="tipoProduto"
      [autofocus]="true"
      [disabled]="formDisabled"
      class="dropdown"
      (onChange)="onChangeTipoProduto($event)"
      required>
    </p-dropdown>
  </div>

  <div [ngClass]="{
                  'produto-exibindo-o-tipo ui-g-8' : !(esconderTipoProduto && tipoProdutoSelecionado),
                  'produto-sem-exibir-o-tipo'      : (esconderTipoProduto && tipoProdutoSelecionado),
                  'padding-top-zero'            : paddingTopZero
                }">
    <span class="md-inputfield">
      <!-- inputId="produtoId" -->
      <!-- <pre>{{resultsetProdutos | json}}</pre> -->
      <p-autoComplete
        #produto
        id="autocompleteProduto"
        [style]="{'width':'100%'}"
        [inputStyle]="{'width':'100%'}"
        name="produto"
        field="label"
        [(ngModel)]="produtoSelecionado"
        [suggestions]="resultsetProdutos"
        [dropdown]="true"
        [size]="resultsetMaxSize"
        [forceSelection]="true"
        [required]="produtoObrigatorio"
        [disabled]="formDisabled"
        (completeMethod)="searchProduto($event)"
        (onFocus)="onFocusProduto($event)"
        (onBlur)="onBlurProduto($event)"
        (onSelect)="onSelectProduto($event)"
        (onClear)="onClearProduto()">
      </p-autoComplete>
      <label>{{ placeholder ? placeholder : tipoProdutoSelecionadoDescricao }}</label>
    </span>
  </div>
</div>
